<div class="modal-canvas__wrapper h100" #wrapperEl>
    <canvas #canvasEl class="modal-canvas__element db" width="0"></canvas>
    <image-placeholder *ngIf="!hasImage" [hasLoaded]="hasLoaded" [size]="loaderBaseHeight" [noImageMessage]="'Not found'"></image-placeholder>
</div>
